var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKrIcono(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1044_19)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 62,
    height: 62,
    rx: 10,
    fill: "url(#paint0_radial_1044_19)",
    fillOpacity: 0.2,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.588 50.4887H68.1285C66.1178 47.3832 62.852 45.0556 58.9805 44.121V41.2129C64.563 42.3216 69.2026 45.8102 71.588 50.4887Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3443 65.4298C68.3345 70.8861 62.2212 74.6185 55.1713 74.6185C45.1365 74.6185 37 67.0551 37 57.7271C37 49.6122 43.157 42.8382 51.3622 41.2129V44.121C44.8555 45.6941 40.0535 51.191 40.0535 57.7271C40.0535 65.4878 46.8225 71.7801 55.1713 71.7801C60.4603 71.7801 65.1124 69.255 67.8162 65.4298H71.3443Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1712 36C55.8144 36 56.3389 36.4876 56.3389 37.0855V50.4883H54.0098V37.0855C54.0098 36.4876 54.5281 36 55.1712 36Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.471 63.0092H59.4299L56.6512 59.3581L56.3389 59.7063V63.0092H54.0098V52.9033H56.3389V56.3397L59.4299 52.9033H62.471L58.1686 57.6689L62.471 63.0092Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0004 63.0091H69.3153L66.8613 59.0794H66.0557V63.0091H63.7266V56.9433H67.2047V57.9881L69.5214 55.8346L67.2047 53.6753V54.7201H63.7266V52.8975H68.1539C68.7471 52.8975 69.2841 53.0368 69.7712 53.3154C70.252 53.594 70.6329 53.9655 70.9139 54.4357C71.1949 54.9059 71.3385 55.4167 71.3385 55.9855C71.3385 56.4209 71.2636 56.8214 71.1075 57.1929C70.9514 57.5644 70.7328 57.8952 70.4456 58.1797C70.1583 58.4641 69.8211 58.6963 69.434 58.8704L72.0129 62.9975L72.0004 63.0091Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1044_19",
    x: 0,
    y: 0,
    width: 116,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1044_19"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "effect1_dropShadow_1044_19",
    result: "effect2_dropShadow_1044_19"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "BackgroundImageFix",
    in2: "effect2_dropShadow_1044_19",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1044_19",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55 55) rotate(90) scale(59)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111C4E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2B2B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrIcono);
export default __webpack_public_path__ + "static/media/kr-icono.79ce3883037e0ae1e0bb4de5366cfe04.svg";
export { ForwardRef as ReactComponent };